import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-down-tail', 'IconArrowDownTail', [
  ['path', { d: 'M12 6v15', key: 'svg-0' }],
  ['path', { d: 'M9 18l3 3l3 -3', key: 'svg-1' }],
  ['path', { d: 'M9 3l3 3l3 -3', key: 'svg-2' }],
]);
